// extracted by mini-css-extract-plugin
module.exports = {"container":"custom-block-content-module--container--1Oumc","columns_2":"custom-block-content-module--columns_2--3gjVW"};